import React, { useContext } from "react";
import ReactDOM from "react-dom";
import { UserContext } from "../Context/UserContext";
import { Link, useLocation } from "react-router-dom";
import "../styleSheets/quicknav.css";

function QuickNav() {
  const location = useLocation();

  const { userDetails } = useContext(UserContext);
  if (userDetails?.role !== "ADMIN") {
    return null;
  }
  const nav = (
    <div className="mobile-bottom-nav bg-dark">
      <Link
        to="/MoneyFlow"
        className={`mobile-nav-item ${
          location.pathname === "/MoneyFlow" ? "mobile-nav-active" : ""
        }`}
      >
        <span className="rupee-icon">₹</span>
        <span>Money Flow</span>
      </Link>

      <Link
        to="/swiggyTracker"
        className={`mobile-nav-item ${
          location.pathname === "/swiggyTracker" ? "mobile-nav-active" : ""
        }`}
      >
        <img
          src="https://1000logos.net/wp-content/uploads/2021/05/Swiggy-emblem.png"
          alt="Swiggy"
          className="swiggy-icon"
        />

        <span>Swiggy Tracker</span>
      </Link>
    </div>
  );

  return ReactDOM.createPortal(nav, document.body);
}

export default QuickNav;
